export function normalizeErrorMessage(error: unknown): string {
  const fallback = 'Ett fel uppstod. Försök igen.';
  if (!error) return fallback;
  const e: any = error as any;
  const payload = e?.error ?? e?.response ?? e;
  const msg = payload?.localizedMessage ?? payload?.message ?? e?.message;
  if (typeof msg === 'string' && msg.trim().length > 0) return msg;
  return fallback;
}

export function extractStatus(error: unknown): number | undefined {
  const e: any = error as any;
  if (typeof e?.status === 'number') return e.status;
  if (typeof e?.response?.status === 'number') return e.response.status;
  return undefined;
}
